// src/components/FeedbackReportPage.js
import React, { useState, useEffect } from 'react';
import { API_BASE_URL, getAuthHeaders } from '../utils/utils';
import './AdminPage.css'; // Reusing the same styles for consistency

const FeedbackReportPage = () => {
  const [feedback, setFeedback] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchFeedback = async () => {
      setIsLoading(true);
      setError('');
      try {
        const response = await fetch(`${API_BASE_URL}/admin/feedback`, {
          headers: getAuthHeaders(),
        });

        if (!response.ok) {
          if (response.status === 403) {
            throw new Error('Access Denied. You do not have permission to view this page.');
          }
          throw new Error('Failed to fetch feedback data.');
        }

        const data = await response.json();
        setFeedback(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFeedback();
  }, []);

  if (isLoading) {
    return <div className="loading-spinner"></div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <div className="admin-page-container">
      <h2>User Feedback Submissions</h2>
      <p>All feedback submissions from users, sorted by most recent.</p>
      <div className="feedback-table-container">
        <table className="feedback-table">
          <thead>
            <tr>
              <th>User Email</th>
              <th>Feedback</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {feedback.map((item) => (
              <tr key={item.id}>
                <td>{item.user_email}</td>
                <td>{item.feedback_text}</td>
                <td>{new Date(item.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FeedbackReportPage;